import { MenuIdHome } from '@jira/navigation-apps__constants/src/MenuIdHome.tsx';
import {
	LazyHorizontalOperationsOverviewNav,
	AsyncHorizontalOperationsOverviewNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getTeamsResource } from '@jira/router-resources__eoc-overview/src/getTeamsResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocOverviewAllTeamsRoute } from '@jira/router-routes__eoc-overview-routes/src/eocOverviewAllTeamsRoute.tsx';
import { eocCommonResources } from '@atlassian/eoc-resources/resources';
import type { Route } from '@atlassian/react-resource-router';
import { EocOverviewAllTeamsComponent, LazyOverviewAllTeamsPage } from './ui/index.tsx';

export const eocOverviewAllTeamsRouteEntry: Route = createEntry(eocOverviewAllTeamsRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: EocOverviewAllTeamsComponent,

	resources: [
		...getNavigationResources(),
		getConsolidationStateResource(),
		getTeamsResource,
		...eocCommonResources(),
	],

	navigation: {
		menuId: MenuIdHome,
		horizontal: AsyncHorizontalOperationsOverviewNav,
	},

	forPaint: [
		LazyAtlassianNavigation,
		LazyHorizontalOperationsOverviewNav,
		LazyOverviewAllTeamsPage,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
